export default "__VITE_ASSET__XRPIh7US__"